import type {
    ResultadoPedidos,
    FiltroPedidos,
    PedidoViewItem,
    ResumoFinanceiro,
    CartaoOnline,
    PixOnline,
    FormaPagamentoResumo,
    EntregadorResumo,
} from "../../../services/dadosPedidoFornecedor"

export type {
    ResultadoPedidos,
    PedidoViewItem,
    ResumoFinanceiro,
    CartaoOnline,
    PixOnline,
    FormaPagamentoResumo,
    EntregadorResumo,
}

export type DadosPedidoFornecedorModel = {
    filtro: FiltroPedidos
    resultado: ResultadoPedidos | null
    pagina: number
    itensPorPagina: number
}

function getHoje(): string {
    const hoje = new Date()
    const dd = String(hoje.getDate()).padStart(2, "0")
    const mm = String(hoje.getMonth() + 1).padStart(2, "0")
    const yyyy = hoje.getFullYear()
    return `${dd}/${mm}/${yyyy}`
}

function getPrimeiroDiaMes(): string {
    const hoje = new Date()
    const mm = String(hoje.getMonth() + 1).padStart(2, "0")
    const yyyy = hoje.getFullYear()
    return `01/${mm}/${yyyy}`
}

export const DadosPedidoFornecedorInicial: DadosPedidoFornecedorModel = {
    filtro: {
        dataInicio: getPrimeiroDiaMes(),
        dataFim: getHoje(),
        horaInicio: "",
        horaFim: "",
        codigo: "",
        cupomDesconto: "",
        plataforma: "",
        idFormaPagamento: "",
        status: "",
        statusPagamento: "",
        emailCliente: "",
        nomeCliente: "",
        tipoPedido: "",
        tipoRecebimentoPedido: "",
        idMotoboy: "",
        idEstabelecimentoFilial: "",
        situacaoCupomFiscal: "",
        grupoFormaPagamento: "",
        exibirPedidosNaoConfirmados: false,
        exibirExpirados: false,
    },
    resultado: null,
    pagina: 0,
    itensPorPagina: 100,
}
